import { render, staticRenderFns } from "./CarerMobile.vue?vue&type=template&id=25056fe4"
import script from "./CarerMobile.vue?vue&type=script&lang=js"
export * from "./CarerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports